<template>
<div>
  <v-container  class="fill-height backcolor" :style="`background-color: ${business.color} ;`">
    
    <v-row  justify-sm="center">
			<v-col cols="12">
				<v-card class="mx-auto elevation-0" max-width="374" :style="`background-color: ${business.color} ;`">
					<v-img :src="business.photo_url"/>
					<v-card-text>
						<CollectionNotFound v-if="!collectionFound"/>
						<Featured v-if="collectionFound"/>
						<SimpleHome v-if="collectionFound  && !business.template "/>
					<!-- 	<ToolBarHome v-if="collectionFound && business.template"/> -->
						<Categories v-if="collectionFound && business.template"/> 
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
  </v-container>
	<Footer v-if="collectionFound"/>
</div>
</template>

<script>
  import { db } from '@/main';
  import { mapState, mapActions } from "vuex";
  export default {
    name: 'IndexEs',
    components: {
      CollectionNotFound: () => import('@/components/es/ColectionNotFound'),
      Featured: () => import('@/components/es/Featured'),
      SimpleHome: () => import('@/components/es/SimpleHome'),
      ToolBarHome: () => import('@/components/es/Toolbar'),
      Categories: () => import('@/components/es/Categories'),
      Footer: () => import('@/components/es/Footer'),

    },
    created(){
			this.setLocalBusiness(this.$route.params.id)

      const refBiss = db.collection('bussiness').doc(this.$route.params.id)
      refBiss.get()
        .then( (snap) => {
          if (snap.exists) {
            this.toggleCollectionFound(true)
            refBiss.onSnapshot((doc) => {
              this.setBussinessId(this.$route.params.id)
              this.setBussiness(doc.data())
            });
            this.setLoaded(true)

          } else {
            this.toggleCollectionFound(false)
            this.setLoaded(true)
          }
        })

    },
    data: () => ({
      businessId: '',
    }),
    methods: {
			...mapActions('businessModule',["setLocalBusiness",]),
			...mapActions(['toggleCollectionFound','setBussiness','setBussinessId', 'setLoaded']),

		},
		computed: {
			...mapState(['collectionFound','loaded']),
			...mapState('businessModule',["business",]),
		},

  }
</script>

<style lang="scss" scoped>

</style>
